export default __webpack_public_path__ + "static/media/Showcase-local-events.fc2d0524.jpg";